import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=44592dbf&scoped=true&"
import script from "./BasketItem.vue?vue&type=script&lang=js&"
export * from "./BasketItem.vue?vue&type=script&lang=js&"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=44592dbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44592dbf",
  null
  
)

export default component.exports